import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bg1 from "../../assets/images/bg/blog.jpg";
import bg from "../../assets/images/bg/blog-M.jpg";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../Config/FbConfig";

export default function Blogs() {
  const navigate = useNavigate();
  const [Blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [bgImage, setBgImage] = useState(window.innerWidth <= 768 ? bg : bg1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    const handleResize = () => {
      setBgImage(window.innerWidth <= 768 ? bg : bg1);
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [bg, bg1]);

  const handleViewDetails = (item) => {
    navigate(`/blog-detail/${item.Id}`, { state: { event: item } });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Pagination logic
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = Blog?.slice(startIndex, endIndex);
  const totalPages = Math.ceil(Blog.length / itemsPerPage);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const docRef = doc(firestore, "Other", "Blog");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const Data = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            Data.push(Object.assign({ Id: key }, value));
          });
          setBlog(Data.sort((a, b) => a.Priority - b.Priority));
          setNoData(Data.length === 0);
        } else {
          setBlog([]);
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching blogs: ", error);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <Navbar
        manuClass="navigation-menu nav-light nav-left"
        containerClass="container"
      />
      <section
        className="bg-half-170 d-table w-100"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: isMobile ? "2rem" : "",
        }}
      >
        <div
          className="bg-overlay bg-overlay-dark"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center">
                <h3 className="sub-title text-white title-dark">
                  Blogs & News
                </h3>
                <p className="para-desc mx-auto text-white-50">
                  The magic of theatre lies in its ability to make us laugh,
                  cry, and reflect all at once.
                </p>
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb bg-light rounded mb-0 py-1 px-2">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li style={{color:"#B9B569"}} className="breadcrumb-item active" aria-current="page">
                      Blogs
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ marginBottom: "1.5rem" }}>
        <div className="container">
          {loading && (
            <div className="text-center" style={{ marginBottom: "1rem" }}>
              <p>Loading...</p>
            </div>
          )}
          {noData && !loading && (
            <div className="text-center" style={{ marginBottom: "1rem" }}>
              <h5>No Data Available</h5>
            </div>
          )}
          {!loading && !noData && (
            <>
              <div className="row">
                {paginatedItems?.map((item, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-12 mb-4 pb-2"
                    key={index}
                  >
                    <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                      <img src={item.Image} className="img-fluid" alt="" />
                      <div className="card-body p-4">
                        <h6 className="one-line-truncate para-desc">
                          {item.Header}
                        </h6>
                        <p className="para-desc text-muted justify six-line-truncate">
                          {item.Description}
                        </p>
                        <div className="post-meta d-flex justify-content-between mt-3">
                          <p
                            onClick={() => handleViewDetails(item)}
                            style={{ cursor: "pointer", color: "#B9B568" }}
                          >
                            Read More
                            <i className="mdi mdi-chevron-right align-middle"></i>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-4">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          style={{ backgroundColor: "#B9B568" }}
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </>
  );
}
